import { render } from "./DefaultModal.vue?vue&type=template&id=a4c71f72&scoped=true"
import script from "./DefaultModal.vue?vue&type=script&lang=js"
export * from "./DefaultModal.vue?vue&type=script&lang=js"

import "./DefaultModal.vue?vue&type=style&index=0&id=a4c71f72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c71f72"]])

export default __exports__